export const mapTestToTable = (inputObject) => {
  try {
    const resultArray = [];
    const dates = Object.keys(inputObject[Object.keys(inputObject)[0]]);
    for (const date of dates) {
      const resultItem = { Date: date };
      for (const testName in inputObject) {
        const vaule = parseFloat(inputObject[testName][date]);
        if (!isNaN(vaule)) {
          resultItem[testName] = vaule;
        }
      }
      resultArray.push(resultItem);
    }

    return resultArray;
  } catch (error) {
    console.log("Error in mapTestToTable:", error);
  }
};
